import $ from "jquery"
import LockTableCellRenderer from "./LockTableCellRenderer"
import IconNameContainer from "../components/IconNameContainer"
import {selectStatusByTask} from "../../workflowStatus/selectors"
import {unsafe_selectWithState} from '../../redux/utils'
import WorkflowStatusIcon from "../../workflowStatus/WorkflowStatusIcon"

export default class LockTableTaskNameCellRenderer extends LockTableCellRenderer {
    constructor(cssClassNames, taskDetailsFunc) {
        super();
        this.cssClassNames = cssClassNames;
        this.taskDetailsFunc = taskDetailsFunc;
    }

    generateContent(cell) {
        new IconNameContainer($(cell.getCellEl()), {
            title: cell.getValue().name,
            icon: new WorkflowStatusIcon(null, unsafe_selectWithState(state => selectStatusByTask(state, cell.getValue()))),
            commentsNumber: cell.getValue().commentsNumber,
            onClick: (e) => {this.taskDetailsFunc(e)},
        }).init()

        if (cell.getValue().available) {
            cell.getRow().getTable().getTooltipController().addTaskTooltip(cell.getCellEl(), cell.getValue())
        } else {
            cell.getRow().getTable().getTooltipController().addNotAvailableTasksTooltip(cell.getCellEl(), cell.getValue())
        }
    }

    getComplicatedBorderClassName(cell) {
        let firstRow = cell.getRow().isFirstChildRow();
        let lastRow = cell.getRow().isLastChildRow();
        if (firstRow || lastRow)
            return (firstRow && lastRow) ? "singleDetailsRow" :
                   (firstRow ? "firstDetailsRow" : "lastDetailsRow");
        else
            return "";
    }

    getCellClassName(cell) {
        return this.cssClassNames;
    }

    updateContent(cell){
        $(cell.getCellEl()).empty();
        this.generateContent(cell);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/LockTableTaskNameCellRenderer.js